import { Directive, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { TargetAppService } from '../../core/services/parameter';
import { NavbarProviderService } from '../services/navbar-provider.service';
import { ComponentProviderDirective } from '../../core/directives/component-provider.directive';

@Directive({
  selector: '[app-navbar]'
})
export class DinamicNavbarDirective extends ComponentProviderDirective {

  constructor(
    protected app: TargetAppService,
    protected provider: NavbarProviderService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected viewContainerRef: ViewContainerRef
  ) {
    super(app, provider, componentFactoryResolver, viewContainerRef);
  }
}
